/* ZSportsTech — section-bat-fit.js
   Animate telemetry bar fills on scroll-into-view.
   Vanilla JS only, no frameworks.
   Maps to → assets/section-bat-fit.js in Shopify theme. */
(function () {
  'use strict';

  var section    = document.getElementById('sc-batfit');
  var telemetry  = document.getElementById('sc-batfit-telemetry');
  if (!section || !telemetry) return;

  var metrics  = Array.prototype.slice.call(
    telemetry.querySelectorAll('.sc-batfit__metric')
  );
  var animated = false;

  /* ── Animate bars 0 → value% ──────────────── */
  function animateBars() {
    if (animated) return;
    animated = true;

    metrics.forEach(function (metric, i) {
      var value = parseInt(metric.getAttribute('data-value'), 10) || 0;
      var fill  = metric.querySelector('.sc-batfit__bar-fill');
      if (!fill) return;

      /* Staggered start so bars fill in sequence */
      setTimeout(function () {
        fill.style.width = value + '%';
      }, i * 80);
    });
  }

  /* ── IntersectionObserver — trigger on view ── */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          animateBars();
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.35 });

    io.observe(telemetry);
  } else {
    /* Fallback — animate immediately */
    animateBars();
  }

  /* ── CTA → quiz route (hook) ──────────────── */
  var cta = section.querySelector('.sc-batfit__cta');
  if (cta) {
    cta.addEventListener('click', function (e) {
      /* Shopify: href already set to quiz route.
         Optionally fire an analytics event here:
         if (window.analytics) analytics.track('Bat Fit CTA Clicked'); */
    });
  }

}());
